import { el } from 'redom';

import InputBox from 'generics/components/input-box';

import DateTimeInputBox from './date-time-input-box';
import DateInput from './date-input';

class DateTimeInputRow {

  constructor(configuration) {

    this.input = new DateTimeInputBox(configuration);

    this.el = el('.form-input-row', [
      el('label.field-label', configuration.label),
      this.input
    ]);

  }

}

export class DateInputRow {

  constructor(configuration) {

    this.inputBox = new InputBox({ input: new DateInput(configuration) });

    this.el = el('.form-input-row', [
      el('label.field-label', configuration.label),
      this.inputBox
    ]);

  }

}

export default DateTimeInputRow;